import { ENV } from '../config/env';
import { apiFetch } from './client';
import { authHeaders } from '../auth/examToken';

const BASE = ENV.NODE_API_BASE;
if (!BASE) console.warn('REACT_APP_NODE_SERVER_URL not set');

const snapshot = () => `${BASE}/api/snapshot`;
const recording = () => `${BASE}/api/recording`;
const answerSheet = () => `${BASE}/api/answer-sheet`;
const violation = () => `${BASE}/api/violation`;

// Every Node API call carries the exam token (Authorization: Bearer ...)
const post = (url, body) => apiFetch(url, { method: 'POST', body, headers: authHeaders() });

// --- Snapshot ---
export async function snapshotCheck(payload) {
  return post(`${snapshot()}/check`, payload);
}

export async function snapshotUpload(payload) {
  return post(`${snapshot()}/upload`, payload);
}

export async function snapshotGet(payload) {
  return post(`${snapshot()}/get`, payload);
}

export async function snapshotReference(payload) {
  return post(`${snapshot()}/reference`, payload);
}

export async function snapshotGetBase64(payload) {
  return post(`${snapshot()}/get-base64`, payload);
}

// --- Recording ---
export async function recordingStart(payload) {
  return post(`${recording()}/start`, payload);
}

export async function recordingPart(formData) {
  return post(`${recording()}/part`, formData);
}

export async function recordingPresign(payload) {
  return post(`${recording()}/presign`, payload);
}

/** PUT a chunk to a presigned S3 URL. Resolves 'stored' or 'duplicate' (412: object already exists); throws otherwise. */
export async function putToS3(url, headers, blob) {
  let res;
  try {
    res = await fetch(url, { method: 'PUT', headers, body: blob });
  } catch (e) {
    const err = new Error(`S3 unreachable: ${e.message}`);
    err.fromS3 = true;
    throw err;
  }
  if (res.ok) return 'stored';
  if (res.status === 412) return 'duplicate';
  const err = new Error(`S3 HTTP ${res.status}`);
  err.status = res.status;
  err.fromS3 = true;
  throw err;
}

export async function recordingEnd(payload) {
  return post(`${recording()}/end`, payload);
}

export function recordingFinalizeUrl() {
  return `${recording()}/finalize`;
}

// --- Answer sheet ---
export async function answerSheetUpload(formData) {
  return post(`${answerSheet()}/upload`, formData);
}

export async function answerSheetGet(payload) {
  return post(`${answerSheet()}/get`, payload);
}

// --- Violation ---
export async function violationUpload(formData) {
  return post(`${violation()}/upload`, formData);
}

export async function violationList(payload) {
  return post(`${violation()}/list`, payload);
}

export async function violationCounts(payload) {
  return post(`${violation()}/counts`, payload);
}

export function getNodeApiBase() {
  return BASE;
}
